/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import ExamenPanel from './ExamenPanel';
import * as validations from '../../validations/validations';
import * as formularioActions from '../../actions/formularioActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";

import withRouter from '../common/withRouter';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';

class ManageExamenForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			formulario:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "Examen",true).then( (usuario)=>{
           let id=this.props.id;
        
            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true); 
            if(id && id>0 ){
            
                this.props.formularioActions.getFormulario(id, usuario).then( formulario=>{
               this.setState({"formulario":formulario});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
  
		
    }
    

    handleChange=(event, data)=> {

        let formulario = this.state.formulario;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		formulario[field[0]]= value;
		else{
             if(!formulario[field[0]]){
                    formulario[field[0]]={}
                }
			formulario[field[0]][field[1]]= value;
		}
        
		
        this.setState({"formulario": formulario});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let formulario=this.state.formulario;
              
        if(!validations.requerido(formulario.nombreFormulario)){
            errors.nombreFormulario=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(formulario.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
    
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        this.state.formulario.examen = 2;
        this.props.formularioActions.save(this.state.formulario, this.props.user).then((examen) => {
            //console.log(examen);        
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/examen/'+examen.id);
            this.props.navigate('/examen/'+examen.id);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
                <Segment  style={margenes}>
                <ExamenPanel 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.formulario}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch)
	};
}

function Parametros(){
    const {id} = useParams();
    const location = useLocation();
    return{
        id
    }
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageExamenForm));